import { useState } from "react";
import classNames from 'classnames';
import {useTranslation} from "react-i18next";

export default function Input({id, label, labelClassName, inputClassName, register, name, type, value, watch, ...props}) {
    const [focused, setFocused] = useState(false);
    const watchValue = watch(name);
    const { t } = useTranslation();

    return (
        <>
            <label className={classNames(labelClassName, {'active': focused || watchValue})} htmlFor={id}>{t(label)}</label>
            <input
                value={value}
                className={inputClassName}
                type={type}
                id={id}
                name={name}
                onBlur={() => setFocused(false)}
                onFocus={() => setFocused(true)}
                ref={register}
                {...props}
            />
        </>
    )
}
